import { Outlet } from 'react-router';

import { SELLER_ROUTES, redirectRoutes } from './seller.routes';
import { normaliseContainerRoutes } from './utils';
import { AppWrapper } from '../AppWrapper';
import { BUYER_ROUTES } from './buyer.routes';

export const routes = [
  {
    element: (
      <AppWrapper>
        <Outlet />
      </AppWrapper>
    ),
    children: [
      {
        path: '/pay',
        children: [
          ...normaliseContainerRoutes(SELLER_ROUTES),
          ...normaliseContainerRoutes(BUYER_ROUTES),
          ...redirectRoutes,
        ],
      },
    ],
  },
];
